<template>
  <c-slider>
    <swiper-slide v-for="(item, index) in banner" :key="index">
      <a :href="item.linkUrl" class="slider-link">
        <img :src="item.picUrl" class="slider-img" />
      </a>
    </swiper-slide>
  </c-slider>
</template>

<script>
  import CSlider from 'base/slider/index';
  import { banner } from './config';

  export default {
    name: 'HomeBanner',
    components: {
      CSlider,
    },
    data() {
      return {
        banner,
      };
    },
  };
</script>

<style lang="scss" scoped>
.slider-link {
  display: block;
  margin: 0 auto;
  width: 96%;
}

.slider-img {
  width: 100%;
}
</style>
